export default __webpack_public_path__ + "static/media/hp-plans-practice-w-friends-img.95dc951d.svg";